import useSWRMutation from 'swr/mutation';
import { DCreateSelfMedicationMessage } from '../data/dtos/message';
import { selfMedicationChatService } from '../services/self-medication';

export function useCreateSelfMedicationMessage({
  userId,
}: Pick<DCreateSelfMedicationMessage, 'userId'>) {
  const execute = async (
    input: Omit<DCreateSelfMedicationMessage, 'userId'>
  ) => {
    return await selfMedicationChatService.sendMessage({
      userId,
      ...input,
      content: input.content?.trim() ?? null,
    });
  };

  const fetchKey = 'send-self-medication-message';
  const { trigger, error, isMutating } = useSWRMutation(
    fetchKey,
    async (_, { arg }: { arg: Omit<DCreateSelfMedicationMessage, 'userId'> }) =>
      await execute(arg)
  );

  return {
    trigger,
    error,
    isLoading: isMutating,
  };
}
